import { Button, Card, Space, Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '@/services/api.service';
import { useAuthStore } from '@/store/authStore';
import EducationPageChrome from './components/EducationPageChrome';

type Blueprint = {
  id: string; name: string; scheme_name?: string | null; subject_name?: string | null;
  grade_name?: string | null; line_count: number;
};

export default function QuestionBlueprintsPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const permissions = useAuthStore((s) => s.user?.permissions || []);
  const canManage = permissions.includes('education.question.manage') || permissions.includes('education.admin');
  const query = useQuery({
    queryKey: ['education-question-blueprints'],
    queryFn: async () => (await api.get<Blueprint[]>('/education/question-blueprints')).data || [],
  });
  return (
    <EducationPageChrome
      title={t('questionBlueprints')}
      extra={<Space>
        <Button onClick={() => navigate('/education/questions')}>{t('back')}</Button>
        {canManage && <Button type="primary" onClick={() => navigate('/education/question-blueprints/new')}>{t('newQuestionBlueprint')}</Button>}
      </Space>}
    >
      <Card size="small">
        <Table rowKey="id" loading={query.isLoading} dataSource={query.data || []} columns={[
          { title: t('name'), dataIndex: 'name' },
          { title: t('assessmentScheme'), dataIndex: 'scheme_name', render: (value) => value || '—' },
          { title: t('subject'), dataIndex: 'subject_name', render: (value) => value || '—' },
          { title: t('grade'), dataIndex: 'grade_name', render: (value) => value || '—' },
          { title: t('blueprintLines'), dataIndex: 'line_count' },
          {
            title: t('actions'),
            render: (_, row: Blueprint) =>
              <Button size="small" onClick={() => navigate(`/education/question-blueprints/${row.id}`)}>{t('open')}</Button>,
          },
        ]} />
      </Card>
    </EducationPageChrome>
  );
}
